import axios from "axios";
import { DataPerPage } from "components/ArticleListing/ui/ArticleContent/ArticleContent";

const articleListingSearch = async (
  path: string,
  offset: number,
  category: string
) => {
  /*
    DO NOT DELETE: http://localhost:4502/libs/cq/search/content/querydebug.html

    path=/content/arbormemorial/ca/en
    type=cq:Page
    1_property.property=jcr:content/cq:template
    1_property.value=/conf/arbormemorial/settings/wcm/templates/article-page
    2_property.property=jcr:content/cq:tags
    2_property.value=experience-fragments:variation/facebook
    p.properties=publicationDate
    orderby=@jcr:content/publicationDate
    orderby.sort=desc
    p.offset=0
    p.limit=20
  */
  const currentPath = window.location.pathname;
  const isEnglish =
    currentPath.includes("/en/") || currentPath.includes("/en.html");
  const lang = isEnglish ? "en" : "fr";

  try {
    const categoryParameter =
      category === "All Articles"
        ? ""
        : `&2_property.property=jcr:content/cq:tags&2_property.value=${encodeURIComponent(
            category
          )}&p.properties=cq:lastModified'`;
    const result = await axios.get(
      `${path}.articles.json?path=/content/arbormemorial/ca/${lang}&type=cq:Page&1_property.property=jcr:content/cq:template&1_property.value=/conf/arbormemorial/settings/wcm/templates/article-page${categoryParameter}&orderby=@jcr:content/publicationDate&orderby.sort=desc&p.offset=${offset}&p.limit=${DataPerPage}`
    );
    return result.data;
  } catch (err) {
    throw err;
  }
};

export default articleListingSearch;
